<template>
  <div id="GuaranteeReport">
    <loading v-if="loadingRender"></loading>
    <panel Title="گزارش ضمانت ها" Des="از طریق این فرم میتوانید گزارشی از ضمانت های خود را مشاهده نمائید" :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <net-pa-card>
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-handshake"></i>
          گزارش ضمانت ها
        </h6>
      </template>
      <template slot="content">
        <div class="guarantee-report-filters" id="Date">
          <p class="guarantee-report-hint">
            نوع ضمانت خود را انتخاب کنید و سپس
            <strong>جستجو</strong>
            را بزنید.
          </p>
          <div class="guarantee-report-filters__row">
            <div class="guarantee-report-field">
              <label class="guarantee-report-label" for="cmbGrp10"
                >انتخاب نوع ضمانت</label
              >
              <select
                name="cmbGrp10"
                id="cmbGrp10"
                class="form-control Pointer"
                v-model="ResultcmbGrp10"
              >
                <option v-if="this.IsLoad == false" value="-2">
                  || در حال بارگذاری ، منتظر بمانید ... ||
                </option>
                <option selected value="-1">-- انتخاب نوع ضمانت --</option>
                <option
                  v-for="item in this.ListModelcmbGrp10"
                  :key="item.id"
                  :value="item.id"
                >
                  <span>{{ item.name }} </span>
                </option>
              </select>
            </div>
            <div class="guarantee-report-field">
              <label class="guarantee-report-label" for="cmbVam"
                >فیلتر تسهیلات</label
              >
              <select name="cmbVam" id="cmbVam" class="form-control Pointer">
                <option selected="selected" value="1">تمام ضمانت ها</option>
                <option value="2">تسهیلات دارای مانده</option>
                <option value="3">تسهیلات معوق</option>
              </select>
            </div>
            <div class="guarantee-report-field guarantee-report-field--action">
              <span
                class="guarantee-report-label guarantee-report-label--spacer"
                aria-hidden="true"
                >&nbsp;</span
              >
              <button
                type="button"
                class="btn btn-success guarantee-report-search-btn"
                @click="
                  GetReport();
                  $ResetTimer();
                "
              >
                <i class="fa fa-search ml-1" aria-hidden="true"></i>
                جستجو
              </button>
            </div>
          </div>
        </div>
        <div class="guarantee-report-cards" dir="rtl">
          <p v-if="!rows.length" class="guarantee-report-cards__empty">
            اطلاعاتی یافت نشد
          </p>
          <template v-else>
            <div class="guarantee-report-cards__toolbar">
              <input
                v-model="cardSearch"
                type="search"
                class="form-control guarantee-report-cards__search"
                placeholder=" جستجو"
                aria-label="جستجو در ضمانت‌ها"
              />
            </div>
            <p
              v-if="filteredCardRows.length === 0"
              class="guarantee-report-cards__empty"
            >
              اطلاعاتی یافت نشد
            </p>
            <div v-else class="guarantee-report-cards__list">
              <article
                v-for="(row, index) in pagedCardRows"
                :key="(row.id || 'row') + '-' + index"
                class="guarantee-report-card"
              >
                <div class="guarantee-report-card__header">
                  <strong class="guarantee-report-card__name">{{
                    row.familyNameVamGirande || row.vCode || 'ضمانت'
                  }}</strong>
                  <span
                    v-if="row.cmbName"
                    class="guarantee-report-card__badge"
                    >{{ row.cmbName }}</span
                  >
                </div>
                <div class="guarantee-report-card__amount">
                  <span dir="ltr">{{ cardValue(row.mande) }}</span>
                  <small>مانده تسهیلات</small>
                </div>
                <div class="guarantee-report-card__fields">
                  <div
                    v-if="row.vCode"
                    class="guarantee-report-card__field"
                  >
                    <span>شماره تسهیلات</span>
                    <strong dir="ltr">{{ row.vCode }}</strong>
                  </div>
                  <div class="guarantee-report-card__field">
                    <span>مبلغ تسهیلات</span>
                    <strong dir="ltr">{{ cardValue(row.mablaghVam) }}</strong>
                  </div>
                  <div class="guarantee-report-card__field">
                    <span>تعداد قسط</span>
                    <strong dir="ltr">{{
                      cardValue(row.tedadGhestVam)
                    }}</strong>
                  </div>
                  <div class="guarantee-report-card__field">
                    <span>مبلغ قسط</span>
                    <strong dir="ltr">{{
                      cardValue(row.mablaghGhestVam)
                    }}</strong>
                  </div>
                  <div class="guarantee-report-card__field">
                    <span>تعداد معوقات</span>
                    <strong dir="ltr">{{
                      cardValue(row.countMoavaghe)
                    }}</strong>
                  </div>
                  <div class="guarantee-report-card__field">
                    <span>تاریخ آخرین قسط</span>
                    <strong>{{ cardValue(row.tarixLastGhest) }}</strong>
                  </div>
                  <div
                    v-if="row.sharh"
                    class="guarantee-report-card__field"
                  >
                    <span>توضیحات</span>
                    <strong>{{ row.sharh }}</strong>
                  </div>
                </div>
              </article>
            </div>
            <div
              v-if="filteredCardRows.length > cardPerPage"
              class="guarantee-report-cards__pager"
            >
              <button
                type="button"
                class="guarantee-report-cards__pager-btn"
                :disabled="cardPage <= 1"
                @click="cardPage = cardPage - 1"
              >
                قبلی
              </button>
              <span class="guarantee-report-cards__pager-info">
                صفحه {{ cardPage }} از {{ cardPageCount }}
              </span>
              <button
                type="button"
                class="guarantee-report-cards__pager-btn"
                :disabled="cardPage >= cardPageCount"
                @click="cardPage = cardPage + 1"
              >
                بعدی
              </button>
            </div>
          </template>
        </div>

        <div class="guarantee-report-table-view">
          <vue-bootstrap4-table
            :rows="rows"
            :columns="columns"
            :config="config"
            :classes="classes"
          >
            <template slot="sort-asc-icon">
              <i class="fa fa-sort-up"></i>
            </template>
            <template slot="sort-desc-icon">
              <i class="fa fa-sort-down"></i>
            </template>
            <template slot="no-sort-icon">
              <i class="fa fa-sort"></i>
            </template>
            <template slot="empty-results">
              <p class="text-right">اطلاعاتی یافت نشد</p>
            </template>
          </vue-bootstrap4-table>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import panel from '../Tools/NetPa/Panel.vue'
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import loading from '../Tools/NetPa/Loading.vue'
export default {
  data() {
    return {
      DataAxios_cmbGrp10: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'SelCombo',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_Zemanat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'Zemantha',
        Token: this.$session.get('TokenNetPa'),
      },
      ListModelcmbGrp10: null,
      IsLoad: false,
      ResultcmbGrp10: null,
      ResultcmbZemanat: null,
      ListModelZemanat: null,
      rows: [],
      cardSearch: '',
      cardPage: 1,
      cardPerPage: 10,
      listData: null,
      columns: [
        {
          label: 'id',
          name: 'id',
          visibility: false,
        },
        {
          label: 'ردیف',
          name: 'row',
        },
        {
          label: 'شماره تسهیلات',
          name: 'vCode',
        },
        {
          label: 'مشخصات',
          name: 'familyNameVamGirande',
        },
        {
          label: 'مبلغ تسهیلات',
          name: 'mablaghVam',
        },
        {
          label: 'تعداد قسط',
          name: 'tedadGhestVam',
        },
        {
          label: 'مانده تسهیلات',
          name: 'mande',
        },
        {
          label: 'مبلغ قسط تسهیلات',
          name: 'mablaghGhestVam',
        },
        {
          label: 'تعداد معوقات',
          name: 'countMoavaghe',
        },
        {
          label: 'توضیحات',
          name: 'sharh',
        },
        {
          label: 'نوع',
          name: 'cmbName',
        },
        {
          label: 'تاریخ آخرین قسط ',
          name: 'tarixLastGhest',
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: '',
        card_mode: false,
        global_search: {
          placeholder: ' جستجو',
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
          searchDebounceRate: 1000,
        },
      },
      classes: {
        table: 'table-bordered table-striped table-sm ',
      },
      loadingRender: false,
    }
  },
  computed: {
    filteredCardRows() {
      const q = (this.cardSearch || '').trim().toLowerCase()
      if (!q) return this.rows
      return this.rows.filter((row) => {
        const hay = [
          row.row,
          row.vCode,
          row.familyNameVamGirande,
          row.mablaghVam,
          row.tedadGhestVam,
          row.mande,
          row.mablaghGhestVam,
          row.countMoavaghe,
          row.sharh,
          row.cmbName,
          row.tarixLastGhest,
        ]
          .filter((v) => v != null && v !== '')
          .join(' ')
          .toLowerCase()
        return hay.includes(q)
      })
    },
    pagedCardRows() {
      const start = (this.cardPage - 1) * this.cardPerPage
      return this.filteredCardRows.slice(start, start + this.cardPerPage)
    },
    cardPageCount() {
      return Math.max(
        1,
        Math.ceil(this.filteredCardRows.length / this.cardPerPage),
      )
    },
  },
  watch: {
    rows() {
      this.cardPage = 1
    },
    cardSearch() {
      this.cardPage = 1
    },
  },
  components: {
    panel,
    NetPaCard,
    VueBootstrap4Table,
    loading,
  },
  mounted() {
    const formData = new FormData()
    formData.append('GrpId', 10)
    this.DataAxios_cmbGrp10.ArryfildValue = formData
    this.$PostFormData(this.DataAxios_cmbGrp10).then((data) => {
      this.IsLoad = true
      if(this.$session.get('CustCode') == 868){
        let list=[];
        data.forEach(el => {
          // if(el.id==4163 || el.id==4031 || el.id==4192){
          //   list.push(el)
          // }
          if( el.id==4031){
            list.push(el)
          }
        });
        this.ListModelcmbGrp10 = list
      }
      else{
        this.ListModelcmbGrp10 = data
      }
      this.ResultcmbGrp10 = data[0].id
    })
  },
  methods: {
    cardValue(val) {
      if (val == null || val === '') return '—'
      return val
    },
    GetReport() {
      this.loadingRender = true
      const formData = new FormData()
      formData.append('wwwtblAzaIdPas', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('CmbID', this.ResultcmbGrp10 == -1 ? null : this.ResultcmbGrp10)
      this.DataAxios_Zemanat.ArryfildValue = formData
      this.$PostFormData(this.DataAxios_Zemanat).then((data) => {
        var cmbVam = document.getElementById('cmbVam')

        switch (cmbVam.options[cmbVam.selectedIndex].value) {
          case '1':
            this.listData = data.filter((x) => x)
            break
          case '2':
            this.listData = data.filter((x) => x.mande > 0)
            break
          case '3':
            this.listData = data.filter((x) => x.countMoavaghe > 0)
            break
          default:
            break
        }
        console.warn(this.listData)

        if (this.listData.length) {
          this.rows = this.$FormatMablaghGrid(this.listData)
          this.loadingRender = false
        } else {
          this.$mySweetDefaultTost('عدم وجود اطلاعات', 'اطلاعاتی یافت نشد ، فیلتر جستجوی خود را تغییر دهید', 'warning', 2000)
          this.config.pagination = false
          this.rows = []
          this.loadingRender = false
        }
      })
    },
  },
}
</script>
<style scoped>
.guarantee-report-filters {
  width: 100%;
  margin: 0 0 1rem;
  padding: 0 0 1rem;
  border-bottom: 1px solid #e8eef2;
}

.guarantee-report-hint {
  margin: 0 0 0.85rem;
  color: #6b7b8e;
  font-size: 13px;
  line-height: 1.7;
}

.guarantee-report-hint strong {
  color: #29345f;
  font-weight: 800;
}

.guarantee-report-filters__row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 0.75rem;
  width: 100%;
}

.guarantee-report-field {
  display: flex;
  flex: 0 1 16rem;
  flex-direction: column;
  max-width: 16rem;
  min-width: 10rem;
  text-align: right;
}

.guarantee-report-field--action {
  flex: 0 0 auto;
  max-width: none;
  min-width: 0;
}

.guarantee-report-label {
  display: block;
  margin-bottom: 0.35rem;
  min-height: 1.25rem;
  color: #29345f;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px !important;
  font-weight: 700;
  line-height: 1.25rem;
}

.guarantee-report-label--spacer {
  visibility: hidden;
  user-select: none;
}

.guarantee-report-field .form-control {
  width: 100%;
  height: 40px;
  min-height: 40px;
  margin: 0;
  padding: 0.4rem 0.75rem;
  color: #13243a;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.guarantee-report-field .form-control:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

.guarantee-report-search-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 6.75rem;
  min-height: 40px;
  height: 40px;
  margin: 0;
  padding: 0 1rem;
  border-radius: 12px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
}

@media (max-width: 767px) {
  .guarantee-report-field,
  .guarantee-report-field--action {
    flex: 1 1 100%;
    max-width: none;
    min-width: 0;
  }

  .guarantee-report-search-btn {
    width: 100%;
  }
}

.guarantee-report-cards {
  display: none;
}

.guarantee-report-cards__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
  margin: 0 0 0.85rem;
}

.guarantee-report-cards__search {
  flex: 1 1 12rem;
  min-width: 0;
  min-height: 40px;
  padding: 0.45rem 0.75rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #dce1e8;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(42, 63, 84, 0.06);
}

.guarantee-report-cards__search:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

.guarantee-report-cards__empty {
  margin: 0.75rem 0 0;
  padding: 1.5rem 1rem;
  color: #6b7b8e;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  border: 1px dashed #dbe5eb;
  border-radius: 14px;
  background: #f8fafc;
}

.guarantee-report-cards__list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.guarantee-report-card {
  padding: 0.95rem 1rem 0.9rem;
  border: 1px solid #e8eef2;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(41, 52, 95, 0.06);
}

.guarantee-report-card__header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem 0.75rem;
  margin-bottom: 0.55rem;
}

.guarantee-report-card__name {
  min-width: 0;
  color: #13243a;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.45;
}

.guarantee-report-card__badge {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0.15rem 0.65rem;
  border-radius: 999px;
  color: #287db4;
  background: #edf5fb;
  font-size: 12px;
  font-weight: 800;
}

.guarantee-report-card__amount {
  margin: 0 0 0.75rem;
  color: #29345f;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.3;
}

.guarantee-report-card__amount small {
  margin-right: 0.3rem;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

.guarantee-report-card__fields {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.guarantee-report-card__field {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
}

.guarantee-report-card__field span {
  flex-shrink: 0;
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

.guarantee-report-card__field strong {
  min-width: 0;
  color: #13243a;
  font-size: 13px;
  font-weight: 700;
  text-align: left;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.guarantee-report-cards__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-top: 0.85rem;
}

.guarantee-report-cards__pager-btn {
  min-height: 34px;
  padding: 0.3rem 0.85rem;
  color: #29345f;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.guarantee-report-cards__pager-btn:disabled {
  opacity: 0.45;
  cursor: default;
}

.guarantee-report-cards__pager-info {
  color: #6b7b8e;
  font-size: 12px;
  font-weight: 700;
}

@media (max-width: 767px) {
  .guarantee-report-cards {
    display: block;
  }

  .guarantee-report-table-view {
    display: none;
  }
}
</style>
